<div *ngIf="item.navCap">
  <div mat-subheader class="nav-caption">
    {{ item.navCap | translate }}
  </div>
</div>

<ng-container *ngIf="!item.navCap && !item.external && !item.twoLines">
  <a
    mat-list-item
    (click)="onItemSelected(item)"
    [ngClass]="{
      'mat-toolbar mat-primary activeMenu': item.route
        ? router.isActive(item.route, true)
        : false,
      expanded: expanded,
      disabled: item.disabled
    }"
    class="menu-list-item"
  >
    <i-tabler
      class="routeIcon"
      [name]="item.iconName"
      matListItemIcon
    ></i-tabler>
    <span class="hide-menu">{{ item.displayName | translate }}</span>
    <span class="arrow-icon" fxFlex *ngIf="item.children && item.children.length">
      <span fxFlex></span>
      <mat-icon [@indicatorRotate]="expanded ? 'expanded' : 'collapsed'">
        expand_more
      </mat-icon>
    </span>
    <span *ngIf="item.chip">
      <span
        class="{{ item.chipClass }} p-x-8 p-y-4 item-chip f-w-500 rounded-pill "
        [matTooltip]="item.chipTooltipKey ? (item.chipTooltipKey | translate) : ''"
        >{{ item.chipContent }}</span
      >
    </span>
  </a>
</ng-container>

<!-- external Link -->
<ng-container *ngIf="!item.navCap && item.external">
  <mat-list-item
    (click)="openExternal(item.route)"
    class="menu-list-item"
  >
    <i-tabler
      class="routeIcon"
      [name]="item.iconName"
      matListItemIcon
    ></i-tabler>
    <span class="hide-menu">{{ item.displayName | translate }}</span>
  </mat-list-item>
</ng-container>

<!-- children -->
<ng-container *ngIf="expanded">
  <app-nav-item
    *ngFor="let child of item.children"
    [item]="child"
    (click)="onSubItemSelected(child)"
    [depth]="depth + 1"
  >
  </app-nav-item>
</ng-container>
